// --- SaniQ ---
import * as ScheduledVisitesConstants from '../constants/ScheduledVisites';

const initialState = {
  index: [],
  isFetching: false
};

export function scheduledVisites(state = initialState, action) {
  switch (action.type) {
    case ScheduledVisitesConstants.FETCH_STARTED:
      return Object.assign({}, state, {isFetching: true});
    case ScheduledVisitesConstants.FETCH_COMPLETED:
      return Object.assign({}, state, {
        index: action.index,
        isFetching: false
      });
    case ScheduledVisitesConstants.FETCH_ENTRY_STARTED: {
      return Object.assign({}, state, {isFetching: true});
    }

    case ScheduledVisitesConstants.FETCH_ENTRY_COMPLETED: {
      return Object.assign({}, state, {isFetching: false});
    }
    default:
      return state;
  }
}
